module.exports = __webpack_public_path__ + "img/galet_calade.f0d0bb10.jpg";